jQuery.noConflict();
jQuery(document).ready(function($){  
   if ($(window).width() >= 1024) {
    if ($('.concern-slider .swiper-slide').length > 6) {
       $('.concern-slider').removeClass('no-slider');
      new Swiper('.concern-slider', {  
        slidesPerView: 5,
        spaceBetween: 0,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 3000,
        },
        breakpoints: {          
          1024: {
            slidesPerView: 6,
            spaceBetween: 24,
          }
        }
      });
    } else {
      //$('.concern-slider').addClass('no-slider');
    }
  } else {  
      $('.concern-slider').removeClass('no-slider');
    // Mobile/tablet: always run slider
    if ($('.concern-slider').length > 0) {
      new Swiper('.concern-slider', {  
        slidesPerView: 1.785,
        spaceBetween: 24,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 3000,
        },  
        breakpoints: {          
          768: {
            slidesPerView: 2.4,
            spaceBetween: 24,
          }
        }
      });
    }
  }
  if ($('.swiper-slide .muteButton').length > 0) {
    $(document).on('click', '.swiper-slide .muteButton', function(e){
      e.preventDefault();
      var $btn   = $(this);
      var $slide = $btn.closest('.swiper-slide');
      var $video = $slide.find('video').first();
      if (!$video.length) return;
      var isMuted = $video.prop('muted');
      $('.communityVideo').prop('muted', true);
      $('.muteButton').removeClass('mute-icon').addClass('unmute-icon');
      if (isMuted) {
        $video.prop('muted', false);
        $btn.removeClass('unmute-icon').addClass('mute-icon');
        if ($video[0].paused) {
          $video[0].play().catch(function(){});
        }
      }
    });
  }

  // Swiper: Artists Slider
  if ($('.testimonial').length > 0) {
    const testimonialsSwiper = new Swiper('.testimonial', { 
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 153000,
      }, 
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1.36,
          centeredSlides: true,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2.22,
          spaceBetween: 18,
        },
        1024: {
          slidesPerView: 3.22,
          spaceBetween: 18,
        },
        1200: {
          slidesPerView: 4.22,
          spaceBetween: 18,
        }
      }
    });
  }
  if ($(window).width() <= 1023) {  
    if ($('.featured-products').length > 0) {
      var featuredSwiper = new Swiper('.featured-products', {
        slidesPerView: 1, 
        loop: true,
        autoplay: {
          delay: 3000,
        },
        breakpoints: {
          320: {
            slidesPerView: 1.5,
          },
          768: {
            slidesPerView: 2
          },
        }
      });
    }
  }

  if ($(window).width() <= 1023) {  
    if ($('.better-products').length > 0) {
      var betterSwiper = new Swiper('.better-products', {
        loop: true,
        autoplay: {
          delay: 3000,
        },
        breakpoints: {
          320: {
            slidesPerView: 1.5
          },
          768: {
            slidesPerView: 2
          },
        }
      });
    }
  }

  /** Testimonials Swiper **/ 
  if ($('.testi-slide').length > 0) {
    const testiSwiper = new Swiper('.testi-slide', {    
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      on: {
        slideChange: function () {
          const realIndex = this.realIndex;
          $('.testiname-item').removeClass('active');
          $('.testiname-item').eq(realIndex).addClass('active');
        }
      }
    });

    // Always use click event
    $('.testiname-item').off('.testiSwiper').each(function (index) {
      $(this).on('click.testiSwiper', function () {
        testiSwiper.slideToLoop(index);
      });
    });

    $('.testiname-item').eq(testiSwiper.realIndex).addClass('active');
  }

  /** Custom accordion **/
  if ($('.benefits-detail .accordion-item button').length > 0) {
    $(".benefits-detail .accordion-item button").on("click", function () {
      $(this).toggleClass("is-open");

      let content = $(this).next();

      if (content.css("max-height") !== "0px" && content.css("max-height") !== "") {
        content.css("max-height", "0");
      } else {
        content.css("max-height", content.prop("scrollHeight") + "px");
      }
    });
  }

  if ($('.popup').length > 0) {
    // Open popup
    $('.details-btn').on('click', function(e){
      e.preventDefault();
      var popupId = $(this).data('popup');
      $('#' + popupId).fadeIn();
    });

    // Close popup when clicking close icon
    $('.popup .close').on('click', function(){
      $(this).closest('.popup').fadeOut();
    });

    // Close when clicking outside popup-content
    $('.popup').on('click', function(e){
      if($(e.target).is('.popup')){
        $(this).fadeOut();
      }
    });
  }

  /* Function to detect mobile */
  function isMobile() {
    return window.innerWidth <= 768;
  }

  /* Product - we stand out js */
  if ($('.we-stand table tbody tr').length > 0) {
    var totalRows = $('.we-stand table tbody tr').length;
    var weStandLimit = isMobile() ? 6 : 10;
    $('.we-stand table tbody tr').hide().slice(0, weStandLimit).show();
    if (totalRows > weStandLimit) {
      $('.center-btn').show();
    } else {
      $('.center-btn').hide();
    }
    $('.compare-btn').on('click', function (e) {
      e.preventDefault();
      $('.we-stand table tbody tr:hidden').show();
      $(this).hide();
    });
  }

  /* Product - ingredients js */
  if ($('.ingredients .ingredient-box').length > 0) {
    var totalItems = $('.ingredients .ingredient-box').length;
    var ingredientsLimit = isMobile() ? 4 : 6;
    $('.ingredients .ingredient-box').hide().slice(0, ingredientsLimit).show();
    if (totalItems > ingredientsLimit) {
      $('.ingredients-btn').show();
    } else {
      $('.ingredients-btn').hide();
    }
    $('.ingredients-btn').on('click', function (e) {
      e.preventDefault();
      $('.ingredients .ingredient-box:hidden').show();
      $(this).hide();
    });
  }

  if (window.innerWidth <= 768) {
    let uls = document.querySelectorAll('.product-box ul');
    let max = Math.max(...[...uls].map(u => u.offsetHeight));
    uls.forEach(u => u.style.height = max + 'px');
  }

  /* Footer mobile social div hide code */
  function toggleFooterSocial() {
    var footerSocial = $('.footer-social');
    if (footerSocial.length) {
      if ($(window).width() <= 768) {
        footerSocial.show();
      } else {
        footerSocial.remove();
      }
    }
  }
  toggleFooterSocial();

  /* SVG inline replacement */
  $('.svg-icon').each(function(){
    var $img = $(this);
    var imgURL = $img.attr('src');

    $.get(imgURL, function(data) {
      var $svg = $(data).find('svg');

      if($img.attr('id')) { $svg.attr('id', $img.attr('id')); }
      if($img.attr('class')) { $svg.attr('class', $img.attr('class') + ' replaced-svg'); }

      $svg.removeAttr('xmlns:a');

      $img.replaceWith($svg);
    }, 'xml');
  });
});

jQuery(window).on('resize', function() {
  var footerSocial = jQuery('.footer-social');
  if (footerSocial.length) {
    if (jQuery(window).width() <= 768) {
      footerSocial.show();
    } else {
      footerSocial.remove();
    }
  }
});

jQuery("span").each(function () {
  if (jQuery(this).text().trim() === "$0.00") {
    jQuery(this).css({
      "text-decoration": "line-through",
      "color": "#999"
    });
  }
});